import React, { useState, useEffect } from "react";
import "../assets/templates/LeadInText.css";
import LessonInstruction from "../containers/instruction/LessonInstruction";
import { useRegisterProgress } from "../hooks/useRegisterProgress";

const ListenAndChoose = ({
  blockData,
  contentIndex,
  audioUrl,
  lessonId,
  totalIndexes,
  step,
}) => {
  const [data, setData] = useState([]);
  const [buttonMsg, setButtonMsg] = useState("Check");

  // hook useRegisterProgress.
  const { registerProgress } = useRegisterProgress(
    blockData.block_id,
    lessonId,
    blockData.sectionId,
    blockData.section,
    blockData.num,
    totalIndexes,
    "listen_and_choose"
  );

  useEffect(() => {
    getWords();
  }, [blockData.block_id]);

  const shuffle = (a) => {
    let j, x, i;
    for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = a[i];
      a[i] = a[j];
      a[j] = x;
    }
    return a;
  };

  const getWords = () => {
    const dataYes = blockData.complement.yes || blockData.complement.Yes;
    const dataNo = blockData.complement.no || blockData.complement.No;
    let arrYes = [];
    let arrNo = [];
    let concatObj = [];

    dataYes.forEach((item) => {
      arrYes.push({
        value: item.img,
        status: "yes",
        originalColor: "green",
        selectedColor: "black",
        clicked: false,
      });
    });

    dataNo.forEach((item) => {
      arrNo.push({
        value: item.img,
        status: "no",
        originalColor: "red",
        selectedColor: "black",
        clicked: false,
      });
    });

    concatObj = arrNo.concat(arrYes);
    setData(shuffle(concatObj));
  };

  const changeColor = (itemValue) => {
    const newData = data.map((value) =>
      value.value === itemValue ? { ...value, clicked: !value.clicked } : value
    );
    setData(newData);
  };

  const checkOrder = () => {
    const updatedData = data.map((value) => ({
      ...value,
      selectedColor: value.originalColor,
      clicked: true,
    }));

    setData(updatedData);
    if (buttonMsg === "Done") {
      setButtonMsg("Check");
      registerProgress();
      step("forward", true);
    } else {
      setButtonMsg("Done");
    }
  };

  const bgColor =
    blockData.content[contentIndex].type === "instruction"
      ? "new-bg-color"
      : "";
  const containerClasses = `default-card container ${bgColor}`;

  return (
    <div className={containerClasses}>
      {blockData.content[contentIndex].type === "instruction" ? (
        <LessonInstruction
          instructionText={blockData.content[contentIndex].instruction}
          audioUrl={audioUrl}
        />
      ) : (
        <div>
          <div
            className="listen-drag-check-maze"
            onClick={() => {
              checkOrder();
            }}
          >
            {buttonMsg}
          </div>
          <div className="row" style={{ paddingLeft: "10%" }}>
            {data.map((item) => (
              <div
                className="col-md-6"
                style={{ padding: "10px" }}
                key={item.value}
              >
                <img
                  alt="ListenAndChoose"
                  src={`${process.env.REACT_APP_CLOUDFRONT_DNS}/media/images/${item.value}`}
                  className="leadInTextImg"
                  onClick={() => changeColor(item.value)}
                  style={{
                    border: "solid 10px",
                    borderColor: item.clicked ? item.selectedColor : "white",
                    width: "auto",
                    height: "250px",
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ListenAndChoose;
